<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class=" mt-4">
        <Activation />
        <b-row>
            <b-col cols="3" class="desktop">
                <InterpreterSidebar class="mt-5" create='active' />
            </b-col>
            <b-col cols="12" md="9">
                <b-row>
                    <b-col>
                        <p class="font18bold">Interpret from Language</p>
                    </b-col>
                    <b-col>
                        <p class="font18bold">To what Language?</p>
                    </b-col>
                </b-row>
                <b-row class="head-box">

                    <b-col cols="12" md="6" class="inner-header-box">
                        <div class="light-input-container">
                            <select class="custom-select" v-model="interpreter.from_language_id">
                                <option value="" selected disabled>Please select language</option>
                                <option v-for="(lang, index) in languages" :key="index" :value="lang.language_id">
                                    {{ lang.name }}
                                </option>
                            </select>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6" class="inner-header-box">
                        <div class="light-input-container">
                            <select class="custom-select" v-model="interpreter.to_language_id">
                                <option value="" selected disabled>Please select language</option>
                                <option v-for="(lang, index) in languages" :key="index" :value="lang.language_id">
                                    {{ lang.name }}
                                </option>
                            </select>
                        </div>
                    </b-col>

                </b-row>
                <div class="form-container">
                    <form action="" @submit.prevent="updateInterpreter">
                        <p class="font18bold">Interpreter Details</p>
                        <div class="row">
                            <b-form-group class="col-md-12 mb-4" label-for="moderator_name">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="tag"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" required v-model="interpreter.title" placeholder="Business name"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="moderator_name">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="briefcase"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="number" required v-model="interpreter.from_lang_experience" placeholder="Years of experience of first language"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="club_name">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="briefcase"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="number" required v-model="interpreter.to_lang_experience" placeholder="Years of experience of second language"></b-form-input>

                                </b-input-group>
                            </b-form-group>

                            <b-form-group class="col-md-6 mb-4" label-for="choice">
                                <b-form-select v-model="interpreter.client_choice" :options="choices"></b-form-select>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="mode">
                                <b-form-select v-model="interpreter.mode" :options="modes"></b-form-select>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="mode">
                                <b-form-select v-model="interpreter.specialization" :options="specializations"></b-form-select>
                            </b-form-group>
                            <b-form-group class="col-md-6 mb-4" label-for="mode">
                                <b-form-select v-model="interpreter.certification" :options="certifications"></b-form-select>
                            </b-form-group>
                            <b-form-group class="col-md-12 mb-4" label-for="mode">
                                <b-form-select v-model="interpreter.translation_type" :options="translations"></b-form-select>
                            </b-form-group>

                            <b-form-group class="col-md-12 mb-3" label-for="reason">
                                <vue-editor :editor-toolbar="customToolbar" placeholder="Reason for wanting this role" v-model="interpreter.reason" />
                            </b-form-group>
                            <b-form-group class="col-md-12 mt-2 mb-2" label-for="input-1">
                                <b-form-checkbox v-model="interpreter.hire_status" switch inline class="col-md-12 my-2 mb-3">
                                    Do you want to be hired ?
                                </b-form-checkbox>
                            </b-form-group>

                        </div>
                        <b-row>
                            <b-form-group class="col-md-12 mb-4" label-for="input-1">
                                <div class="file-container mb-4">
                                    <p>Upload Interpreter Avatar</p>
                                    <div @click="openFile" class="btn btn-warning">Choose File
                                        <b-icon scale="0.8" icon="cloud-arrow-up"></b-icon>
                                    </div>
                                    <b-form-file @change="showFileName" style="visibility:hidden" id="interpreterAvatar" class="mt-3" plain></b-form-file><span>{{ filename }}</span>
                                </div>
                            </b-form-group>
                        </b-row>

                        <b-row class="mt-4">
                            <b-form-group class=" col-md-12 mb-4" label-for="input-1">
                                <button class="float-right btn btn-warning">{{ btnText }}
                                    <font-awesome-icon :icon="['fas', 'arrow-right']" />
                                </button>
                            </b-form-group>
                        </b-row>
                    </form>
                </div>
            </b-col>
        </b-row>
    </b-container>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
import InterpreterSidebar from "@/components/InterpretersSidebar.vue";
import axios from "axios";
import {
    getBaseUrl
} from "../../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'create-interpreter-profile',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        InterpreterSidebar,
        Activation,
        Footer
    },
    data: function () {
        return {
            headerText: "Update Interpreter Profile ",
            subText: "Help to translate from one language to another",
            fadedText: "Language",
            btnText: 'Update profile',
            terms: false,
            filename: '',
            customToolbar: [
                ["bold", "italic", "underline"],
                [{
                    list: "ordered"
                }, {
                    list: "bullet"
                }]
            ],
            choices: [{
                    value: null,
                    text: 'Select Client Choice'
                },
                {
                    value: "individual",
                    text: "Individual"
                },
                {
                    value: "corporate",
                    text: "Corporate"
                },
                {
                    value: "any",
                    text: "Any"
                },
            ],
            certifications: [{
                    value: null,
                    text: 'Are you certified?'
                },
                {
                    value: "yes",
                    text: "Yes"
                },
                {
                    value: "no",
                    text: "No"
                }
            ],
            translations: [{
                    value: null,
                    text: 'Can you also Translate Official Documents?'
                },
                {
                    value: "yes",
                    text: "Yes"
                },
                {
                    value: "no",
                    text: "No"
                }
            ],
            modes: [{
                    value: null,
                    text: 'Select Mode'
                },
                {
                    value: "in-person",
                    text: "In Person"
                },
                {
                    value: "phone",
                    text: "Telephone"
                },
                {
                    value: "online",
                    text: "Online"
                },
            ],
            specializations: [{
                    value: null,
                    text: 'Select specialization'
                },
                {
                    value: "conference",
                    text: "Conference"
                },
                {
                    value: "media",
                    text: "Media"
                },
                {
                    value: "medical",
                    text: "Medical"
                },
                {
                    value: "tour",
                    text: "Tour Guide or Escort"
                },
                {
                    value: "legal",
                    text: "Legal"
                },
                {
                    value: "s-lang",
                    text: "Sign Language"
                },
                {
                    value: "religion",
                    text: "Religion"
                },
                {
                    value: "speech",
                    text: "Public Speech"
                },
                {
                    value: "finance",
                    text: "Finance or Investment"
                },
            ],
            interpreter: {
                from_language_id: '',
                to_language_id: '',
                from_lang_experience: '',
                to_lang_experience: '',
                reason: '',
                photo: '',
                choice: '',
                mode: '',
                specialization: '',
                certification: '',
                translation_type: '',
                hire_status: false,
            },
            showInterpreterDetails: false,
            disabled: true,
            disableBtn: true,
            showDropdown: false,
            showBtn: true,
            languages: [],

        }
    },
    computed: {
        disableButton: function () {
            const resp = this.from_language_id !== '' && this.to_language_id !== '' ? false : true;
            return resp;
        }
    },
    mounted() {
        this.getLanguages()
        this.getInterpreter()
    },
    methods: {
        openTerms() {
            let routeData = this.$router.resolve({
                name: 'terms'
            });
            window.open(routeData.href, "_blank")
        },
        openFile() {
            document.getElementById('interpreterAvatar').click()
        },
        showFileName() {
            const file = document.getElementById('interpreterAvatar').files[0];
            this.filename = file.name
        },
        async getLanguages() {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/languages`,
                    method: "GET",
                })
                this.languages = resp.data.data;
                this.showDropdown = true
            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async getInterpreter() {
            const id = this.$route.params.id;
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/language/interpreters/${id}`,
                    method: "GET",
                })
                this.interpreter = resp.data.data;
                this.interpreter.hire_status = this.interpreter.hire_status == 0 ? false : true;
                this.interpreter.specialization = this.interpreter.specializations[0].title
            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }

        },
        async updateInterpreter() {
            this.btnText = 'Updating profile...'
            const hireStatus = this.interpreter.hire_status == true ? 1 : 0;
            let specializations = []
            specializations.push(this.interpreter.specialization)
            const image = document.getElementById("interpreterAvatar").files[0]
            let data = new FormData();
            if (image) {
                data.append("photo", document.getElementById("interpreterAvatar").files[0]);
            }
            data.append('title', this.interpreter.title)
            data.append('from_language_id', this.interpreter.from_language_id)
            data.append('to_language_id', this.interpreter.to_language_id)
            data.append('reason', this.interpreter.reason)
            data.append('from_lang_experience', this.interpreter.from_lang_experience)
            data.append('to_lang_experience', this.interpreter.to_lang_experience)
            data.append('hire_status', hireStatus)
            data.append('client_choice', this.interpreter.client_choice)
            data.append('mode', this.interpreter.mode)
            data.append("certification", this.interpreter.certification)
            specializations.forEach((item) => data.append("specializations[]", item))
            data.append("translation_type", this.interpreter.translation_type)

            const interpreterId = this.interpreter.interpreter_id;
            try {
                await axios({
                    url: `${base_url}/api/v2/language/interpreters/${interpreterId}?_method=PUT`,
                    data: data,
                    method: "POST",
                })
                this.btnText = 'Update profile';
                this.$router.push("/languages/interpreters/created");

            } catch (error) {
                this.btnText = 'Update profile'
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }

        }
    }
}
</script>

<style scoped>
.row {
    margin-left: 0 !important;
}

.bordered {
    border-left: 2px solid #ccc;
}

.time-frame {
    background: rgba(247, 177, 49, 0.15);
    border-radius: 16px;
    padding: 2px 13px;
    text-transform: uppercase;
    margin-top: 10px
}

.btn-grey {
    background: #565C63 !important;
    border-radius: 4px !important;
    color: #fff !important
}

.light-input-container {
    border: 1px solid rgba(86, 92, 99, 0.54);
    padding: 10px;
    border-radius: 5px;
    background: #fff;
}

.custom-input-group {
    box-shadow: none !important;
    margin: 0 !important
}

.custom-input-group .input-group-prepend {
    padding-top: 18px !important;
}

.btn-culture {
    padding: 10px 60px !important;
}

.form-control {
    height: calc(2em + 0.75rem + 15px) !important;

}

.input-group {
    margin: 0
}

.form-control:focus {
    outline: none !important;
    box-shadow: none !important;
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.bi-search {
    margin-right: 1rem;
}

.custom-select .caret {
    padding-right: 10px;
}

.custom-control {
    height: calc(1.5em + 0.75rem + 15px) !important;

}

.btn-box {
    margin: 14px 0
}

.head-box {
    margin: 15px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    background-color: #F6F7F7;
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.font18bold {
    font-size: 18px;
    font-weight: 500;
}

.font24bold {
    font-size: 24px;
    font-weight: 500;
}

.custom-notify {
    border-radius: 8px;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-in-out !important;
}

.country-list-span {
    background: #000;
    color: #fff;
    padding: 15px 30px;
    border-radius: 8px;
    margin-right: 25px;
}

.autocomplete-list {
    top: 62px !important;
    text-align: left !important;
    width: 100% !important
}

.autocomplete-list ul li {
    border: none !important;
    transition: all 0.1s ease-in-out !important;
}

.autocomplete-list ul li:hover {
    background: #F6F7F7;
}

.country-list-span span:nth-child(2) {
    cursor: pointer
}

.autocomplete-list img,
.country-list-span img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}

.elevated {
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%)
}
</style>
